// Auto-generated compilation artifact for LossRewardPool.sol
// Compiler: Solidity 0.8.26 (Optimizer: enabled, 200 runs)

export const LOSS_REWARD_POOL_ABI = [
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_operator",
        "type": "address"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [],
    "name": "AlreadyClaimed",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "ArrayLengthMismatch",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "EpochAlreadyPublished",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "EpochNotPublished",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "EthTransferFailed",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InsufficientUnallocatedPool",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidMerkleRoot",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidProof",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "ReentrancyGuardReentrantCall",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "Unauthorized",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "ZeroAddress",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "ZeroAmount",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "token",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "epochId",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "bytes32",
        "name": "merkleRoot",
        "type": "bytes32"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "allocatedAmount",
        "type": "uint256"
      }
    ],
    "name": "EpochRootPublished",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOperator",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOperator",
        "type": "address"
      }
    ],
    "name": "OperatorUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "token",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "epochId",
        "type": "uint256"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "claimant",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "RewardClaimed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "token",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "sender",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "RewardDeposited",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "token",
        "type": "address"
      },
      {
        "internalType": "uint256[]",
        "name": "epochIds",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "amounts",
        "type": "uint256[]"
      },
      {
        "internalType": "bytes32[][]",
        "name": "merkleProofs",
        "type": "bytes32[][]"
      }
    ],
    "name": "claimBatch",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "token",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "epochId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      },
      {
        "internalType": "bytes32[]",
        "name": "merkleProof",
        "type": "bytes32[]"
      }
    ],
    "name": "claimReward",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "token",
        "type": "address"
      }
    ],
    "name": "depositReward",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "epochAllocatedAmounts",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "epochMerkleRoots",
    "outputs": [
      {
        "internalType": "bytes32",
        "name": "",
        "type": "bytes32"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "token",
        "type": "address"
      }
    ],
    "name": "getUnallocatedBalance",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "hasClaimed",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "operator",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "token",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "epochId",
        "type": "uint256"
      },
      {
        "internalType": "bytes32",
        "name": "merkleRoot",
        "type": "bytes32"
      },
      {
        "internalType": "uint256",
        "name": "allocatedAmount",
        "type": "uint256"
      }
    ],
    "name": "setEpochMerkleRoot",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_operator",
        "type": "address"
      }
    ],
    "name": "setOperator",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "totalAllocated",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "totalClaimed",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "totalDeposited",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  }
] as const;

export const LOSS_REWARD_POOL_CREATION_BYTECODE = '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' as const;

export const LOSS_REWARD_POOL_DEPLOYED_BYTECODE = '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' as const;

export const LOSS_REWARD_POOL_CONSTRUCTOR_ARGS_ZERO_ADDR = '0x0000000000000000000000000000000000000000000000000000000000000000' as const;

export const LOSS_REWARD_POOL_FULL_DEPLOY_DATA = '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' as const;
